import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import { DataService } from './data.service';
import { SharedGlobals } from './shared-globals.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class MenuService {


constructor(private storage: Storage, public dataService: DataService, public sharedGlobals: SharedGlobals, public router: Router){}

  
  convertMenu(menu) {

    var menuClean = [];
	var menuItem: any;
    var title = '';
    var subtitle = '';
    var post_type = '';
    var data_url = '';
    var icon = '';
    var thumbnail = '';
    var url = '';
    var group_by = '';
    var group_cat = '';
    var group_keyorder = '';
    var locked_content = '0';
    var pass_protected = '0';
    
    // slider
    var slider_autoplay = '0';
    var slider_slides_num = '3';
    
    // submenu
    var menu_elements = '';
    var submenu_image = '';
    var post_open = '';
    var post_open_id = '';
    var extraData: any;
    

	for (var i = 0; i < menu.length; i++) {

		if (menu[i].component) {
        
            title = menu[i].menuTitle;
            post_type = menu[i].post_type;
            data_url = menu[i].data_url;
            group_by = menu[i].group_by;
            group_cat = menu[i].group_cat;
            group_keyorder = menu[i].group_keyorder;
            locked_content = menu[i].locked_content;
            pass_protected = menu[i].pass_protected;
            
            menu_elements = menu[i].menu_elements;
            submenu_image = menu[i].submenu_image;
            
            slider_autoplay = menu[i].slider_autoplay;
            slider_slides_num = menu[i].slider_slides_num;
            
            icon = menu[i].icon;
            url = menu[i].url;
            thumbnail = menu[i].thumbnail;
            subtitle = menu[i].menuSubTitle;
            
            post_open = menu[i].post_open;
            post_open_id = menu[i].post_open_id;
            
            
            
        
			switch (menu[i].component) {
				case "EventlistPage":
					menuItem = { menuTitle: title, path: 'eventlist/'+post_type, post_type: post_type, data_url: data_url, icon: icon, group_keyorder: group_keyorder, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
					break;
				case "ListPage":
                    menuItem = { menuTitle: title, path: 'list/'+post_type, post_type: post_type, data_url: data_url, icon: icon, group_by: group_by, group_cat: group_cat, group_keyorder: group_keyorder, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
					break;
				case "ListcolPage":
					menuItem = { menuTitle: title, path: 'listcol/'+post_type, post_type: post_type, data_url: data_url, icon: icon, group_by: group_by, group_cat: group_cat, group_keyorder: group_keyorder, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
					break;
                case "UserListPage":
                    menuItem = { menuTitle: title, path: 'userlist', post_type: post_type, data_url: data_url, icon: icon, group_by: group_by, group_cat: group_cat, group_keyorder: group_keyorder, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
					break;
				case "SliderListPage":
					menuItem = { menuTitle: title, path: 'sliderlist/'+post_type, post_type: post_type, data_url: data_url, icon: icon, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected, slider_autoplay: slider_autoplay, slider_slides_num: slider_slides_num};
					break;
				case "MapWebPage":
					menuItem = { menuTitle: title, path: 'mapweb/'+post_type, post_type: post_type, data_url: data_url, icon: icon, group_by: group_by, group_cat: group_cat, group_keyorder: group_keyorder, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
					break;
				case "AppWebBrowser":
					menuItem = { menuTitle: title, path: 'inappbrowser', post_type: post_type, data_url: data_url, icon: icon, url: url, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
					break;
				case "HomePage":
					menuItem = { menuTitle: title, path: 'home', post_type: post_type, data_url: data_url, icon: icon, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected};
                    break;
                case "SubMenuList":
                    menuItem = { menuTitle: title, path: 'submenulist', menu_elements: this.convertMenu(menu_elements), thumbnail: thumbnail};
					break;
                case "SubMenuListCol":
                    menuItem = { menuTitle: title, path: 'submenulistcol', menu_elements: this.convertMenu(menu_elements), thumbnail: thumbnail};
					break;
                case "Detail":
                    menuItem = { menuTitle: title, path: 'detail/'+post_open_id, post_type: post_type, data_url: data_url, icon: icon, thumbnail: thumbnail, post_open: post_open, post_open_id: post_open_id, openFrom: 'menu'};
					break;
                case "AccountPages":

                    // if webversion - simulate opening inappbrowser
                    
                    if(this.sharedGlobals.webVersion === true) {
                        menuItem = { menuTitle: this.dataService.getLang('Log-in'), path: 'inappbrowser', post_type: 'openbrowser', data_url: data_url, icon: icon, url: url, thumbnail: thumbnail, menuSubTitle: subtitle, locked_content: locked_content, pass_protected: pass_protected}
                        break
                    }

                    var accountComponent;
                    if (this.sharedGlobals.curLoggedUser === '') { // not logged in
                        title = this.dataService.getLang('Log-in');
                        if (title === 'Log-in') {
                            title = this.sharedGlobals.logIn[this.sharedGlobals.lang]; //fallback, first load
                        }
                    }
                    else {
                        title = this.dataService.getLang('Account page');
                    }
                    // controller is modally presented, from app.component.ts, component here is dummy
                    menuItem = { menuTitle: title, path: 'detailuser', post_type: post_type, data_url: data_url, icon: icon, url: url, locked_content: locked_content, pass_protected: pass_protected};
                    
                  
                    
			}     
		}   
        
        // THIS WAS SET, comment if bugs... -  if (menu[i].component != "EventlistPage") { }
        this.dataService.setCurDataObjTempDict(menuItem);
        
        if (!(locked_content === '1' && this.sharedGlobals.curLoggedUser === '')) {
            if (menuItem.path != 'inappbrowser') { 
                menuClean.push(menuItem);
            }
            else { // for outer links, dont display in menu if protected
                if (!this.dataService.isProtected(menuItem)) {
                    menuClean.push(menuItem);
                }
            }
        }
        
        title = post_type = icon = url = '';
	}
    
    
    return menuClean;

}




navigateLoggedOutUser() {
    // set post type before navigating
    console.log('NAVIGATE LOGGED OUT USER')
    // get first item in curdataobjDict
    for (var key in this.dataService.curDataObjDictionary) {
        this.sharedGlobals.curDataObj = this.dataService.curDataObjDictionary[key];
        break
    }   
    
    this.router.navigate(['home']);
}


navigateToUserProfilesList() {
    // set post type before navigating
    this.sharedGlobals.curDataObj = this.dataService.getCurDataObjTempDictForPostType('profiles')
    this.router.navigate(['userlist']);
}


navigateToUserProfile() {
    // set post type before navigating
    this.router.navigate(['profile']);
}







  

// defaults
  getMenuFront() {
    let result = [
      { menuTitle: 'Program', path: 'eventlist', post_type: 'blank' },
      { menuTitle: 'Speakers', path: 'listcol', post_type: 'speaker' },
      { menuTitle: 'News', path: 'sliderlist', post_type: 'post' },
      // { menuTitle: 'Showcase', path: 'inappbrowser', post_type: 'openbrowser', url: 'https://goldendrum.com/showcase/' },
      { menuTitle: 'Gallery', path: 'list', post_type: 'galerija_slik' },
      { menuTitle: 'Map', path: 'mapweb', post_type: 'location' },
      { menuTitle: 'Info', path: 'list', post_type: 'pageinfo' }
    ];

    return result;
  
  }
  
  getMenuRear() {
    let result = [
      // { menuTitle: 'Sponzorji', path: 'inappbrowser', post_type: 'openbrowser', url: 'https://akademija-finance.si/24gd/sponsors-app/' },
      // { menuTitle: 'Medijsko središče', path: 'list', post_type: 'press' },
      { menuTitle: 'About App', path: 'eventlist', post_type: 'pageinfo' },
    ];
    
    return result;
  
  }
  
  

  getDefaultDayMenu() {
    let result = [
      { "order": 0, "edate": "2024-02-14T00:00:00+02:00", "dayTitle": "FRI", "daySubtitle": "Feb 14" },
      { "order": 1, "edate": "2024-02-15T00:00:00+02:00", "dayTitle": "SAT", "daySubtitle": "Feb 15" }
    ];
    
    return result;
    
  }

  
  
  
  
  getDefaultGraphics() {
  
    let result = [{
            "order": 0,
            "img": "",
			"img_bckg": "",
            "img_bckg2": "",
			"class": "grph1"
		}];
    
    return result;
    
  }

  
  
}
